// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		//Call function with browser is resized.
		// $(window).resize(function (event) {
		// 	resizeWindow();
		// });
		// resizeWindow();

		// ANIMATE ANCHOR SCROLL ON CLICK
		document.querySelectorAll('.js-scrollTo').forEach(btn => {
			btn.addEventListener('click', e => {
				const currentTarget = document.querySelector( btn.getAttribute('href') );
				e.preventDefault();
				if ( currentTarget ) {
					$('html, body').stop().animate({ scrollTop: currentTarget.offsetTop }, 600);
				} else {
					console.warn(`${btn.getAttribute('href')} does not exists.`);
				}
			});
		});

		// LANG LIST TOGGLE
		if ( document.querySelector('.languages__active') ) {
			document.querySelector('.languages__active').addEventListener('click', _ => {
				document.querySelector('.languages__options').classList.toggle('open');
			});
		}

		// BURGER
		if ( document.querySelector('.header_toggle') ) {
			document.querySelector('.header_toggle').addEventListener('click', _ => {
				document.querySelector('.headerNav').classList.toggle('open');
			});
			document.querySelector('.headerNav__close').addEventListener('click', _ => {
				document.querySelector('.headerNav').classList.toggle('open');
			});
		}
		
		// Login Popup
		if ( document.querySelector('.header_login') ) {
			document.querySelector('.header_login').addEventListener('click', _ => {
				document.querySelector('.loginPopup').classList.toggle('open');
				document.querySelector('.forgot__password').classList.add('hidden');
				document.querySelector('.login').classList.remove('hidden');
			});
			document.querySelector('.loginPopup__close').addEventListener('click', _ => {
				document.querySelector('.loginPopup').classList.toggle('open');
			});
		}

		//Open form forgot password
		if(document.querySelector('.forgot')){
			document.querySelector('.forgot').addEventListener('click', _ => {
				document.querySelector('.login').classList.toggle('hidden');
				document.querySelector('.forgot__password').classList.toggle('hidden');
			});
			document.querySelector('.loginPopup__close.forgot').addEventListener('click', _ => {
				document.querySelector('.loginPopup').classList.toggle('open');
			});
		}

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		document.getElementById('header').classList.add('scroll');
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		document.getElementById('header').classList.remove('scroll');
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}